window.spm = window.spm || {
	push: () => {}
};

window._czc = window._czc || {
	push: () => {}
}

export default {
  markPoint: (mpEvent, mpMenu, mpItem, value) => {
	  _czc.push(['_trackEvent', `${mpEvent || 'mpRrror'}`, '1', '1']);
	  spm.push({
	    category: mpEvent || 'mpRrror',
	    action: 'visite',
      value: 1
	  });
  }
}


// WEBPACK FOOTER //
// ./src/pages/mark.js